import classNames from 'classnames'
import DropdownFilter from '../ui/DropdownFilter/DropdownFilter'
import ToggleButton from '../ui/ToggleButton/ToggleButton'
import styles from './MediaPdfsLayout.module.scss'

function MediaPdfsFilter({
  yearFilter,
  pdfTypeFilter,
  sortFilter,
  selectedFilter,
  handleFilterChange,
  containerClass,
  filtersClass,
}) {
  return (
    <div className={classNames(styles.container, containerClass)}>
      <div className={classNames(styles.filtersContainer, filtersClass)}>
        {selectedFilter?.selectedpdfType && (
          <ToggleButton
            title={pdfTypeFilter?.label}
            options={pdfTypeFilter?.list}
            selectedOption={selectedFilter?.selectedpdfType}
            selectedOptionKey={'selectedpdfType'}
            handleChange={handleFilterChange}
          />
        )}
        {selectedFilter?.selectedYear && (
          <DropdownFilter
            title={yearFilter?.label}
            options={yearFilter?.list}
            selectedOption={selectedFilter?.selectedYear}
            selectedOptionKey={'selectedYear'}
            handleChange={handleFilterChange}
            className={styles.yearFilter}
          />
        )}
      </div>
      {selectedFilter?.selectedSortType && (
        <DropdownFilter
          title={sortFilter?.label}
          options={sortFilter?.list}
          selectedOption={selectedFilter?.selectedSortType}
          selectedOptionKey={'selectedSortType'}
          handleChange={handleFilterChange}
          className={styles.sortByFilter}
        />
      )}
    </div>
  )
}

export default MediaPdfsFilter
